import useScript from "components/Shared/Hooks/useScript"
import { isFeatureEnabled } from "config/feature-flags"
import { MEDALLIA_FEATURE_FLAG, MEDALLIA_SOURCE } from "constants/medallia"

const useExternalScripts = () => {
	useScript(MEDALLIA_SOURCE, {
		shouldPreventLoad: !isFeatureEnabled(MEDALLIA_FEATURE_FLAG),
	})
}

export default useExternalScripts
